module.exports = __webpack_public_path__ + "img/video_stub.c5a684f8.png";